import { SpxTsData } from '../BandChart.types';

export const getDirectionalArrays = (ts: SpxTsData[]) => {
  let lastSeen = '';
  const thresholds = ts.reduce((acc, tsPoint) => {
    const context = tsPoint['direction'] || '';
    const switchContext = lastSeen !== context;
    !acc.length || switchContext
      ? acc.push([tsPoint])
      : acc[acc.length - 1].push(tsPoint);
    lastSeen = context;
    return acc;
  }, [] as SpxTsData[][]);
  return thresholds;
};
